export class FormSanctionModel {

  typeAnnulationPermis36DerniersMois: string;
  typeSuspensionPermis36DerniersMois: string;
  annulationPermisAvecOuSansSinistre36DerniersMois: string;
  annulationPermisMotif36DerniersMois: string;
  dateInitialPermisApresAnnulation: string;
  dateAnnulationPermis36DerniersMois: string;
  suspensionPermisMotif36DerniersMois: string;
  dateSuspensionPermis36DerniersMois: string;
  // dateInfraction36DerniersMois: string;
  typeSanction: string;
  dateSanction36DerniersMois: string;
  // dureeSanction36DerniersMois: number;
  nombreSuspensionPermis36AvecSinistreDerniersMois: number;
  nombreSuspensionPermis36SansSinistreDerniersMois: number;
  nombreMoisSuspensionPermis36DerniersMois: number;

  constructor() {}
}
